import PersonalInfoChangeForm from './personal-info-change-form';
export default PersonalInfoChangeForm;
